import { lazy } from "react";

const OrdenCompraLayout = lazy(() =>
      import("../../ordencompra/OrdenCompraLayout.jsx")
);

const OrdenesCompra = lazy(() =>
      import("../../ordencompra/OrdenesCompra.jsx")
);

const OrdenCompraForm = lazy(() =>
      import("../../ordencompra/OrdenCompraForm.jsx")
);

const ordenCompraRoutes = [
      {
            path: "ordencompra",
            element: <OrdenCompraLayout />,
            children: [
                  { index: true, element: <OrdenesCompra /> },
                  { path: "editar", element: <OrdenCompraForm /> },
            ],
      },
];

export default ordenCompraRoutes;
